import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ImageIcon } from 'lucide-react';
import { fetchGallery } from '@/services/api';

interface GalleryImage {
    id: number;
    title: string;
    image: string;
    slug: string;
    thumbnail: string;
}

const GalleryPreview = () => {
    const [images, setImages] = useState<GalleryImage[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchHomGallery = async () => {
            try {
                const response = await fetchGallery(); // Replace with your actual API endpoint
                const data = response.data;
                console.log(data)

                // Transform API response if needed
                const galleryItems = data.slice(0, 6);
                const formatted = galleryItems.map((item: any) => ({
                    id: item.id,
                    title: item.title,
                    date: item.date,
                    images: item.images || 0,
                    thumbnail: item.thumbnail || 'https://res.cloudinary.com/dwrqyrm84/image/upload/q_auto,f_auto/t_center_logo/v1747853348/ulqyzwzdazyrxpderkzr.jpg', // Default Unsplash photo
                }));

                // setGalleryItems(formatted);
                setImages(formatted); // preview only top 6
            } catch (error) {
                console.error('Failed to fetch gallery:', error);
                setImages([]);
            } finally {
                setLoading(false);
            }
        };

        fetchHomGallery();
    }, []);

    return (
        <section className="py-16 bg-gradient-to-br from-purple-50 to-purple-100 py-20 px-6 text-center border-t border-purple-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-10 text-center">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Photo Gallery</h2>
                    <p className="text-gray-600">Explore moments from our events and activities.</p>
                </div>

                {loading ? (
                    <div className="text-center text-gray-500">Loading...</div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {images.map(image => (
                            <Card key={image.id} className="overflow-hidden shadow-md group hover:shadow-lg transition">
                                <Link to={`/gallery/${image.id}`}>
                                    <img
                                        src={image.thumbnail}
                                        alt={image.title}
                                        className="w-full h-60 object-cover group-hover:scale-105 transition-transform"
                                    />
                                    <CardContent className="p-4">
                                        <h3 className="text-lg font-semibold text-gray-800 truncate">{image.title}</h3>
                                    </CardContent>
                                </Link>
                            </Card>
                        ))}
                    </div>
                )}

                <div className="mt-10 text-center">
                    <Button asChild variant="outline">
                        <Link to="/gallery">
                            <ImageIcon className="h-5 w-5 mr-2" /> View Full Gallery
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default GalleryPreview;
